const projects = Object.freeze({
  DEFAULT: 'ONESOLUTION',
  CWM: 'cwm',
  KNOX: 'knox services',
  TUTTOSMART: 'tuttosmart',
  EQS: 'eqs',
  ENI: 'portale selfcare',
  TIM: 'TIM Enterprise',
  ITALGAS: 'italgas',
})

export default {
  computed: {
    projects() {
      return projects
    },
    webenv() {
      // solo demo/test: forza il tenant (es. VUE_APP_FORCE_WEBENV=TIM) quando l'hostname non lo contiene,
      // ad esempio dietro un URL di port forwarding. Non impostata = riconoscimento da hostname.
      const forced = process.env.VUE_APP_FORCE_WEBENV
      if (forced && projects[forced.toUpperCase()]) return projects[forced.toUpperCase()]

      const { hostname } = window.location

      if (hostname.indexOf('cwm') > -1) return projects.CWM

      if (
        hostname.indexOf('mdm.windtrebusiness.it') > -1 ||
        hostname.indexOf('knox') > -1
      )
        return projects.KNOX

      if (hostname.indexOf('tuttosmart') > -1) return projects.TUTTOSMART
      if (hostname.indexOf('eqs') > -1) return projects.EQS
      if (hostname.indexOf('italgas') > -1) return projects.ITALGAS
      if (hostname.indexOf('eni') > -1) return projects.ENI
      if (hostname.indexOf('tim') > -1) return projects.TIM

      return projects.DEFAULT
    },

    visualSettings() {
      const defaults = {
        loginBackground: require('@assets/images/background_login.jpg'),
        appbarColor: '#FFFFFF',
        appbarDark: false,
        footerVisible: false,
        footerColor: '#004691',
        footerDark: true,
        footerHeight: '120vh',
        frontPageTitle: '<strong>ONE</strong>SOLUTION',
        frontPageSubtitle: 'Powered by Ennova',
        frontPageBoxTitle: 'Accedi',
        accent: 'primary',
        secondary: 'blue',
      }

      switch (this.webenv) {
        case projects.KNOX:
          return {
            ...defaults,
            loginBackground: require('@assets/images/windtre_bg_login.jpg'),
            appbarColor: '#08080D',
            appbarDark: true,
            footerVisible: true,
            footerColor: '#58595b',
            footerDark: true,
            footerHeight: '120vh',
            frontPageTitle: 'DIGITAL SOLUTIONS',
            frontPageSubtitle:
              'Ottimizza la produttività del tuo business e migliora le relazioni commerciali con i tuoi clienti',
            frontPageBoxTitle: 'Knox Manage Plus',
            accent: 'orange darken-3',
            secondary: 'grey darken-2',
            displayCta: true,
          }

        case projects.ITALGAS:
          return {
            ...defaults,
            appbarColor: '#003da5',
            appbarDark: true,
            frontPageTitle: 'Portale Selfcare Italgas',
            frontPageSubtitle:
              'Supporto completo per la gestione delle SIM aziendali Italgas.',
            footerVisible: true,
          }

        case projects.ENI:
          return {
            ...defaults,
            appbarColor: '#FFFFFF',
            appbarDark: true,
            frontPageTitle: 'TIM per ENI',
            frontPageSubtitle:
              "Supporto completo per la gestione, la sicurezza e l'assistenza degli smartphone della tua azienda.",
            footerVisible: true,
          }

        case projects.TUTTOSMART:
          return {
            ...defaults,
            appbarColor: '#FFFFFF',
            appbarDark: true,
            frontPageTitle: 'TUTTO SMART',
            frontPageSubtitle:
              "Supporto completo per la gestione, la sicurezza e l'assistenza degli smartphone della tua azienda.",
            footerVisible: true,
          }

        case projects.TIM:
          return {
            ...defaults,
            appbarColor: '#FFFFFF',
            appbarDark: true,
            frontPageTitle: 'TIM',
            frontPageSubtitle:
              "Supporto completo per la gestione, la sicurezza e l'assistenza degli smartphone della tua azienda.",
            footerVisible: true,
            // etichette di menu/pagine per tenant (chiave = menu.js `key`)
            menuLabels: { customers: 'Aziende' },
            // il contatore Kasko in dashboard non ha senso per i clienti TIM
            hideKaskoCounter: true,
            // voce "Dashboard" nel menu laterale
            showDashboardMenu: true,
            // elenco aziende subito visibile nel campo Cliente (poche aziende per utente)
            prefillCustomers: true,
            // dashboard: niente card "Richieste di Assistenza"; inventario asset per Brand + Modello
            hideSupportRequests: true,
            assetsInventoryByModel: true,
          }

        case projects.CWM:
          return {
            ...defaults,
            appbarColor: '#FFFFFF',
            appbarDark: true,
            frontPageTitle: '<strong>cloud</strong>workplace',
            frontPageSubtitle: 'm a n a g e m e n t',
            footerVisible: true,
          }

        default:
          return defaults
      }
    },

    // etichetta per tenant con fallback (es. 'Clienti' -> 'Aziende' per TIM)
    tenantLabels() {
      return this.visualSettings.menuLabels || {}
    },

    isMagicLink() {
      return this.$route.params.magic_link
    },

    currentTenantCapabilities() {
      const userProjects = this.$store.state.auth?.current?.projects || []
      // In produzione webenv corrisponde al key del progetto (da hostname).
      // In locale (localhost) webenv ritorna DEFAULT: si usa il primo progetto utente se univoco.
      const key =
        this.webenv !== projects.DEFAULT
          ? this.webenv
          : userProjects.length === 1
          ? userProjects[0].key
          : null
      if (!key) return {}
      const match = userProjects.find((p) => p.key === key)
      return (match && match.capabilities) || {}
    },

    currentTenantTicketSearch() {
      return this.currentTenantCapabilities.ticket_search || {}
    },

    currentTenantTicketDetail() {
      return this.currentTenantCapabilities.ticket_detail || {}
    },

    currentTenantCustomerUser() {
      return this.currentTenantCapabilities.customer_user || {}
    },
  },
}
